/**
 * WP Swiper Plugin JavaScript
 * Version: 1.0.0
 */

(function($) {
    'use strict';
    
    // Initialize when DOM is ready
    $(document).ready(function() {
        initWPSwipers();
    });
    
    /**
     * Initialize all Swiper instances
     */
    function initWPSwipers() {
        // Initialize default swiper containers
        $('.wp-swiper-container .swiper').each(function() {
            var swiperElement = this;
            
            // Get configuration from data attributes or use defaults
            var config = {
                // Default configuration
                loop: true,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                scrollbar: {
                    el: '.swiper-scrollbar',
                    draggable: true,
                },
                // Responsive breakpoints
                breakpoints: {
                    640: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 30,
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 40,
                    },
                }
            };
            
            // Override config with data attributes if present
            if ($(swiperElement).data('swiper-config')) {
                var customConfig = $(swiperElement).data('swiper-config');
                config = $.extend(true, config, customConfig);
            }
            
            // Initialize Swiper
            new Swiper(swiperElement, config);
        });
    }
    
    /**
     * Public function to create custom swiper
     */
    window.wpSwiperInit = function(selector, customConfig) {
        var defaultConfig = {
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            }
        };
        
        var config = $.extend(true, defaultConfig, customConfig || {});
        return new Swiper(selector, config);
    };
    
})(jQuery);